<template>
  <div class="wrappers">
    <div class="text-left pb-3">{{ $t('选择目的地') }}<span class="text-sm">（{{ $t('默认出发地为昆明') }}）</span></div>
    <div class="flex items-center">
      <el-select :value="$t('昆明')" :placeholder="$t('请选择')" disabled>
        <el-option v-for="option in areas" :key="option.id" :label="option.name" :value="option.id">
        </el-option>
      </el-select>
      <div class="iconfont icon-go text-main px-5" ></div>
      <el-select v-model="form.end_aid" :placeholder="$t('请选择')">
        <el-option v-for="option in areas" :key="option.id" :label="option.name" :value="option.id">
        </el-option>
      </el-select>
    </div>
    <div class="text-left py-3">{{ $t('航班时间') }}</div>
    <div class="flex items-center">
      <el-date-picker v-model="form.date" type="date" :placeholder="$t('选择日期')" value-format="yyyy-MM-dd">
      </el-date-picker>
      <el-button type="primary" round @click="searchFlight" class="ml-16">{{ $t('查询航班') }}</el-button>

    </div>
    <div class="planes">
      <div class="plane-info" v-for="item in pager.items" :key="item.ident">
        <div>
          <div class="plane-title" v-if="item.airline">
            <img :src="item.airline.img" class="round cu-avatar">
            <div class="ml-2">{{ item.airline.name }} {{ item.ident }}</div>
          </div>
          <div class="plane-title" v-else>{{ item.ident }}</div>
        </div>
        <div class="plane-frequency">
          <div class="depart">
            <div class="place">{{ item.start_airport }}</div>
            <div class="time">{{ $t('出发') }}：{{ getTime(item.start.timestamp) }}</div>
          </div>
          <div class="through">
            <div class="consum">{{ item.duration }}</div>
            <div class="iconfont icon-Group489 icon"></div>
          </div>
          <div class="depart">
            <div class="place">{{ item.end_airport }}</div>
            <div class="time">{{ $t('到达') }}：{{ getTime(item.end.timestamp) }}</div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="!pager.items.length" class="flex-center pb-5">
      <img :src="require(`@/assets/image/暂无收藏.png`)" class="mx-auto" />
    </div>
    <!-- <div class="flex-center mt-5" v-else>
      <el-button  type="primary" round @click="getMore">{{ $t('查看更多') }}</el-button>
    </div> -->
  </div>
</template>
<script>
import Search from "@/components/flight/search.vue";
import { ref, reactive, onMounted } from "@vue/composition-api";
import { getAreas } from "/src/API/flight/getAreas.js";
export default {
  components: { Search, },
  props: { q: Object },
  setup(props, ctx) {


    // 所需数据
    let form = reactive({
      date: new Date().format('yyyy-MM-dd'),
      start_aid: 3,
      end_aid: ''
    })

    // 区域
    let areas = ref([])
    onMounted(async () => {
      let res = await ctx.root.$callapi("getNationalData",{tag:'airplane'})
      areas.value = res.data?.areas || []

    })
    // 交换
    const switchPort = () => {
      let aid = form.start
      form.start = this.form.end
      form.end = aid
    }
    // 查询
    const searchFlight = () => {
      for (let key in form) {
        if (!form[key]) {
          return ctx.root.$toast(ctx.root.$t('请把信息选择完整'))
        }
      }

      pager.value.first()


    }
    // 航班列表数据
    let e_airport_code = ref('')
    let s_airport_code = ref('')
    const pager = ref(
      new ctx.root.$Pager({
        apiname: 'getFlightList',
        param: form,
        onLoaded: (res) => {
          if (res.code == 0 && res.data) {
            s_airport_code.value = res.data.s_airport_code
            e_airport_code.value = res.data.e_airport_code
          }
        }
      })
    )

    // 格式化航班时间
    const getTime = (timestamp) => {
      return ctx.root.$formatStamp(timestamp, "yyyy-M-d hh:mm")
    }
    // 更多
    const getMore = ()=>{
      window.open(`https://zh.flightaware.com/live/findflight?origin=${s_airport_code.value}&destination=${e_airport_code.value}`)
    }
    return { form, areas, switchPort, searchFlight, pager, getTime,getMore };
  },
};
</script>
<style lang="scss" scoped>
@import "@/style/theme.scss";

.wrappers {
  @apply bg-white py-5 px-5 bg-white;

  .planes {
    @apply grid gap-5 mt-10;
    grid-template-columns: repeat(2, 1fr);

    .plane-info {
      @apply border py-4 px-3 rounded;

      .plane-title {
        @apply pb-2;

        .cu-avatar {
          width: 2rem;
          height: 2rem;
        }

        display: flex;
        align-items: center;
        // font-size: $font-lg;
      }

      .price {
        font-size: 30rpx;
        color: #FF8B03;
      }

      .plane-frequency {
        display: grid;
        grid-template-columns: 1fr minmax(80px, 130px) 1fr;
        grid-column-gap: 10px;

        .depart {
          display: flex;
          flex-direction: column;
          align-items: center;

          .place {
            display: flex;
            text-align: center;
            justify-content: center;
          }

        }

        .through {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          // width: 100%;

          .number {
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .icon {
            display: flex;
            align-items: center;
            justify-content: center;
            // width: 100%;
            transform: scale(0.18, 0.2);
            color: #10BC56;
          }

          .consum {
            display: flex;
            align-items: center;
            text-align: center;
            justify-content: center;
          }
        }
      }



      .add-on {

        // margin-top: $spacing-base;
        // color:$font-grey;
        .stock-box {
          display: flex;
          width: 100%;
          align-items: center;

          .stock-title {
            display: flex;
            align-items: center;
          }
        }
      }
    }
  }
}
</style>
